/**
 * Builds a display name from first + last name only.
 * Do not use displayName or email — those are not part of the name rule.
 */
export type UserNameParts = {
  firstName?: string | null;
  lastName?: string | null;
};

export const formatUserFullName = (user: UserNameParts): string =>
  `${user.firstName || ''} ${user.lastName || ''}`.trim();

/**
 * True when a stored person label is real text, not blank and not the
 * `${undefined} ${undefined}` corruption left by the deprecated `displayName` field.
 */
export const isUsablePersonName = (value?: string | null): value is string => {
  if (typeof value !== 'string') return false;
  const trimmed = value.trim();
  return Boolean(trimmed) && !/^undefined(\s+undefined)*$/i.test(trimmed);
};
